export default "__VITE_ASSET__CE0HHnX7__"